import { render, staticRenderFns } from "./ModalAAprovacaoAtaSolicitacaoAlteracaoValor.vue?vue&type=template&id=78b5f71c"
import script from "./ModalAAprovacaoAtaSolicitacaoAlteracaoValor.vue?vue&type=script&lang=js"
export * from "./ModalAAprovacaoAtaSolicitacaoAlteracaoValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports